angular.module('account.add-article', [
  'common.header',
  'common.footer',
  'config',
  'directives.contenteditable',
  'account.settings.social',
  'security.service',
  'security.authorization',
  'services.accountResource',
  'services.utility',
  'services.formErrors',
  'ui.bootstrap',
  'directives.serverError',
  'ngTagsInput',
  'ngFileUpload',
  'toggle-switch',
  'angular-growl',
  'ckeditor',
  'resources.User',
  'resources.Category',
  'resources.Article',
  'resources.Tag',
  'filters.rawHtml',
  'ckeditorPlaceholder',
  'services.localizedMessages',
])

.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('account.add-article', {
      url: '/add-article',
      title: 'Add Article',
      views: {
        'main@': {
          template: require('./add-article.tpl.html'),
          controller: 'AddArticleCtrl',
          resolve: {
            categories: ["Category", function(Category) {
              var options = [];
              var generateCategoryOptions = function(items, container) {
                items.forEach(function(item) {
                  if (!item.path) {
                    return;
                  }
                  var depth = item.path.split('/').filter(Boolean).length;
                  var indent = (new Array(5)).join(String.fromCharCode(160));
                  container.push({
                    _id: item._id,
                    id: item.id,
                    path: item.path,
                    sefriendly: item.sefriendly,
                    parent: item.parent,
                    parent_id: item.parent_id,
                    name: item.name,
                    _name: (new Array(depth)).join(indent) + item.name
                  });
                  if (item.children) {
                    generateCategoryOptions(item.children, container);
                  }
                });
                return container;
              };

              return Category.getPermittedTree().$promise.then(function(data) {
                generateCategoryOptions(data, options);
                return options;
              });
            }],
            locations:  ["adminResource", function(adminResource) {
              return adminResource.searchTags({type: 'location'})
            }],
            playersAndTeams:  ["adminResource", function(adminResource) {
              return adminResource.searchTags({type1: 'profile', type2: 'organization'})
            }],
          }
        }
      }
    });
}])

.controller('AddArticleCtrl',
  ["$scope", "$location", "$log", "$interval", "security", "utility", "growl", "user", "categories", "locations", "playersAndTeams", "adminResource", "SOCIAL", "STATUSES", "ARTICLE_STYLES", "APP_IMG_URLS", "Upload", "formErrors", "dateFilter", "Article", "Tag", "localizedMessages", function(
    $scope,
    $location,
    $log,
    $interval,
    security,
    utility,
    growl,
    user,
    categories,
    locations,
    playersAndTeams,
    adminResource,
    SOCIAL,
    STATUSES,
    ARTICLE_STYLES,
    APP_IMG_URLS,
    Upload,
    formErrors,
    dateFilter,
    Article,
    Tag,
    localizedMessages
  )
  {
      $scope.localizedMessages = localizedMessages;
      STATUSES = STATUSES.map( (status) => Object.assign(status, { value: localizedMessages.get(status.value) }) );
      var urlGenerated = false;
      var now = new Date();
      var timer = null;
      var currentDateTime = moment();
      var slugify = require('../../utils/slugify');

      $scope.statuses = _.filter(STATUSES, function (status) {
        return ~user.permissions.statuses.indexOf(status.id);
      });
      if (user.permissions.statuses[0] === '*') {
        $scope.statuses = STATUSES;
			}
			$scope.statuses.map(s => {
				s.value = s.value.split("?").join('');
			});
      $scope.categories = categories;
      $scope.stadiumsList = !!locations ? locations.data.map(function (p) {
        return {_id: p._id, name: p.name}
      }) : [];
      $scope.playersAndTeamsList = !!playersAndTeams ? playersAndTeams.data.map(function (p) {
        return {
          _id: p._id,
          name: p.name,
          type: p.role.role_type
        }
      }) : [];
      $scope.profilesList = $scope.playersAndTeamsList.length ? $scope.playersAndTeamsList.filter(function(e) {
        return e.type === 'profile';
      }) : [];
      $scope.article_styles = ARTICLE_STYLES;
      $scope.alerts = [];
      $scope.uploading = false;
      $scope.isSaving = false;
      $scope.autosaveTimer = 180;
      $scope.imgUrl = APP_IMG_URLS['base'];
      $scope.accordion = {
        score: true,
        publishing_date: true,
        url: true,
        image: true,
        published_by: false
			};
			
			$scope.ckOptions = {
				language: 'pl',
				uiColor: '#08152B'
			};

      $scope.isAdmin = false;
      if (user.permissions.is_admin) {
        $scope.isAdmin = true;
        console.log("$scope.isAdmin------->>>>>>>" + $scope.isAdmin);
      }
      $scope.data = {
        title: '',
        sefriendly: '',
        status: {
          id: '0',
          value: localizedMessages.get('pending')
        },
        image: '',
        video: '',
        image_caption: '',
        body: '',
        abstract: '',
        equipo_local: '',
        equipo_visitante: '',
        goals: '',
        goles_local: '',
        goles_visitante : '',
        referee: '',
        incidents: '',
        show_inarticle: ARTICLE_STYLES[1],
        category: '',
        tags: '',
        author: {
          picture : user.account.avatar || user.account.picture,
          twitter : user.account.twitter,
          plus : user.account.plus,
          name: user.account.name.full,
          username: user.username
        },
        orderNumber:0,
        last_edited_by: {
          name: user.account.name.full,
          username: user.username
        },
        published_by: {
          name: '',
          username: ''
        },
        publish_date: currentDateTime.local().format('YYYY-MM-DD HH:mm')
      };

      var startTimer = function () {
        return $interval(function () {
          if ($scope.autosaveTimer <= 0) {
            $scope.save();
          }
          $scope.autosaveTimer -= 1;
        }, 1000);
      };

      var resetTimer = function () {
        $scope.autosaveTimer = 180;
        $interval.cancel(timer);
      };

      $scope.autosaveChanged = function () {
        if ($scope.autosave) {
          timer = startTimer();
        }
        else {
          resetTimer();
        }
      };

      $scope.titleChanged = function() {
        $scope.data.title=$scope.data.title.replace(/<.+?>/g,"").replace(/  /g," ")
        if ($scope.data.sefriendly) {
          return;
        }
        $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g,"").replace(/  /g," "));
        // console.log('>>>', $scope.data.sefriendly);
      };

      $scope.canChangeAuthor = function () {
        return user.permissions.is_editor && $scope.canChangeCategory();
      };

      $scope.canChangeCategory = function () {
        if (user.permissions.is_admin) return true;
        return true

        // return ~user.permissions.categories.indexOf(article.category.id);
      };

      $scope.save = function(){
        resetTimer();
        $scope.autosaveChanged();
        $scope.data.sefriendly = slugify($scope.data.sefriendly);

        //validate
        if (!$scope.data.title) {
          growl.error('Title is required');
          return;
        }

        if (!$scope.data.category) {
          growl.error('Category is required');
          return;
        }

        if (!$scope.data.body) {
          growl.error('Body is required');
          return;
        }

        $scope.isSaving = true;

        var data = angular.copy($scope.data);

        data.edition = data.category.path.split("/")[1];
        data.show_inarticle = parseInt(data.show_inarticle.id, null);
        data.status = parseInt(data.status.id, null);
        data.category = {
          id: data.category.id,
          name: data.category.name,
          sefriendly: data.category.sefriendly,
          parent: data.category.parent,
          parent_id: data.category.parent_id
        }

        data.tags = data.tags || [];
        data.tags = data.tags.map(function (tag) {
          return {
            name: tag.text,
            sefriendly: slugify(tag.text)
          };
        });

        data.publish_date = (data.publish_date ? moment(data.publish_date) : currentDateTime).toISOString();

        if (!$scope.canChangeAuthor()) {
          data.last_edited_by = {
            name: user.account.name.full,
            username: user.username
          };
        }

        if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
          data.published_by = {
            name: user.account.name.full,
            username: user.username
          }
        }

        var catArray = data.category.parent == "/" ? [] : data.category.parent.substring(1).split('/');
        var pDate = new Date(data.publish_date);
        var pMonth = pDate.getUTCMonth() + 1;
        var dateSeg = '/' + pDate.getUTCFullYear()
                    + '/' + ('0' + pMonth).slice(-2)
                    + '/' + ('0' + pDate.getUTCDate()).slice(-2)
                    + '/';
        data.url_segment = dateSeg;
        if(catArray.length == 0) {
          data.url_segment = '/' + data.category.sefriendly + dateSeg;
        } else if(catArray.length == 1){
          data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
        } else if(catArray.length > 1) {
          data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
        }

        // console.log( '>>> data.body', data.body );
        Article.save(data, function(result) {
          setTimeout(function () {
            growl.info('Article have been created.');
            $location.path('/account/edit-article/' + result.article_id);
          }, 1000);
        }, formErrors.growlErrors).$promise.then(function () {
        	setTimeout(function () {
            		$scope.isSaving = false;
          	}, 5000);
	});
      };

      $scope.$on('$locationChangeStart', function (event, next, current) {
          if (!$scope.isSaving) {
             return true;
	     //var answer = confirm("Are you sure you want to navigate away from this page");
             //if (!answer) {
               //  event.preventDefault();
             //}
          }
      });

      $scope.$watch('file', function (file) {
        if (!file) return;
        $scope.upload(file);
      });

      // upload on file select or drop
      $scope.upload = function (file) {
        $scope.uploading = true;
        $scope.thumbnail = file;
        Upload.upload({
          url: '/api/articles/upload',
          data: {file: file}
        }).then(function (resp) {
          $scope.uploading = false;
          $scope.thumbnail = APP_IMG_URLS.base + resp.data.filename;
          $scope.data.image = resp.data.filename;
        }, function (resp) {
          $scope.uploading = false;
          $scope.thumbnail = null;
          console.log('Error status: ' + resp.status);
        }, function (evt) {
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        });
      };

      $scope.loadTags = function (query) {
        return Tag.search({q: query}).$promise.then(function (tags) {
          if (!tags) return [];
          return tags.map(function (tag) {
            return {
              _id: tag._id,
              text: tag.nametag,
              name: tag.nametag,
              oficial: tag.oficial,
              sefriendly: tag.name
            }
          })
        });
      };
      try {
          $('span.input').each(function(element){
            $(this).text("Dodaj tag")
          })
      } catch (error) {
        
      }

      $scope.changePT1 = function(pt1) {
        var playerOrTeam = $scope.playersAndTeamsList.filter(function(e){
          return e._id === pt1;
        });
        if(playerOrTeam.length) {
          $scope.data.equipo_local_name = playerOrTeam[0].name;
        }
      }

      $scope.changePT2 = function(pt2) {
        var playerOrTeam = $scope.playersAndTeamsList.filter(function(e){
          return e._id === pt2;
        });
        if(playerOrTeam.length) {
          $scope.data.equipo_visitante_name = playerOrTeam[0].name;
        }
      }

      $scope.loadProfiles = function (query) {
        return adminResource.searchTags({type: 'profile', name: query}).then(function (profiles) {
          if (!profiles) return [];
          var searchName = query.toLowerCase();
          return profiles.data.filter(function(p){
            var name = p.name.toLowerCase();
            return name.indexOf(searchName) > -1 ;
          }).map(function (p) {
            return {
              _id: p._id,
              name: p.name,
            }
          })
        });
      };
    }]);



// WEBPACK FOOTER //
// ./client/src/app/account/add-article/add-article.js